import { render } from "./Academy.vue?vue&type=template&id=3d8859f9&ts=true"
import script from "./Academy.vue?vue&type=script&lang=ts"
export * from "./Academy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__